import { getRequest } from "./api";

export const initMenu = (router, store) => {
    if (store.state.routes.length > 0) {
        return;
    }

    getRequest('/user/menu').then(data => {
        if (data) {
            //格式化Router
            let fmtRoutes = formatRoutes(data.result);
            //添加到router
            router.addRoutes(fmtRoutes);
            //将数据存入vuex
            store.commit('initRoutes', fmtRoutes);
            //连接WebSocket
        }
    })
}


export const formatRoutes = (routes) => {
    let fmtRoutes = [];
    routes.forEach(router => {
        let {
            path,
            component,
            name,
            iconCls,
            children,
        } = router;
        if (children && children instanceof Array) {
            //递归
            children = formatRoutes(children);
        }
        let fmRouter = {
            path: path,
            name: name,
            iconCls: iconCls,
            children: children,
            component(resolve) {
                if (component.startsWith('Home')) {
                    require(['../views/' + component + '.vue'], resolve);
                } else if (component.startsWith('Cons')) {
                    require(['../views/cons/' + component + '.vue'], resolve);
                } else if (component.startsWith('Cust')) {
                    require(['../views/cust/' + component + '.vue'], resolve);
                } else if (component.startsWith('Sale')) {
                    require(['../views/sale/' + component + '.vue'], resolve);
                } else if (component.startsWith('Wlog')) {
                    require(['../views/wlog/' + component + '.vue'], resolve);
                } else if (component.startsWith('Proj')) {
                    require(['../views/proj/' + component + '.vue'], resolve);
                } else if (component.startsWith('Plat')) {
                    require(['../views/plat/' + component + '.vue'], resolve);
                } else if (component.startsWith('File')) {
                    require(['../views/file/' + component + '.vue'], resolve);
                } else if (component.startsWith('Depa')) {
                    require(['../views/depa/' + component + '.vue'], resolve);
                } else if (component.startsWith('Need')) {
                    require(['../views/need/' + component + '.vue'], resolve);
                } else if (component.startsWith('Slms')) {
                    require(['../views/slms/' + component + '/index.vue'], resolve);
                } else if (component.startsWith('Certi')) {                  //测试列表
                    require(['../views/certi/' + component + '.vue'], resolve);
                } else if (component.startsWith('CarUse')) {                  //测试列表
                    require(['../views/usecar/' + component + '.vue'], resolve);
                } else if (component.startsWith('Meal')) {                  //测试列表
                    require(['../views/meal/' + component + '.vue'], resolve);
                } else if (component.startsWith('Work')) {
                    require(['../views/work/' + component + '.vue'], resolve);
                } else if (component.startsWith('Ding')) {
                    require(['../views/ding/' + component + '.vue'], resolve);
                } else if (component.startsWith('Money')) {
                    require(['../views/money/' + component + '.vue'], resolve);
                }else if (component.startsWith('Ainv')) {
                    require(['../views/ainv/' + component + '/index.vue'], resolve);
                } else if (component.startsWith('Goods')) {
                    require(['../views/goods/' + component + '/index.vue'], resolve);
                } else if (component.startsWith('Screen')) {
                    require(['../views/screen/' + component + '.vue'], resolve);
                } else if (component.startsWith('Video')) {
                    require(['../views/video/' + component + '.vue'], resolve);
                } else if (component.startsWith('Document')) {
                    require(['../views/document/' + component + '.vue'], resolve);
                } else if (component.startsWith('Wflow')) {
                    require(['../views/wflow/' + component + '.vue'], resolve);
                }
                //路由找到本地文件
            }
        }
        fmtRoutes.push(fmRouter)
    });
    return fmtRoutes;
}
